let headerSearch
function vueSearch() {
    headerSearch = Vue.createApp({
        delimiters: ['#{', '}'],
        setup() {
            const showSearchBox = Vue.ref(false);

            const searchTerm = Vue.ref('');

            const searchStore = window.search();
            const promo = window.promo();

            const searchResults = Vue.ref({
                products: [],
                suggestions: [],
                content: false
            });

            const unsearched = Vue.ref(true);

            const showSearch = () => {
                showSearchBox.value = !showSearchBox.value;
            }

            const keyPress = (event) => {
                if(event.key == 'Enter') {
                    searchStore.submitSearch(searchTerm.value)
                }
            }


            let requestId = 0
            let debounceId
            let controllers = {};

            async function predSearch(input) {
                const query = searchStore.inputTest(input.trim())[0]
                if(controllers[`${requestId}`]) controllers[`${requestId}`].abort();
                clearTimeout(debounceId)
                if (!query) {
                    unsearched.value = true;
                    searchResults.value.content = false;
                    return
                }

                debounceId = setTimeout(async () => {
                    const currentId = ++requestId
                    controllers[`${currentId}`] = new AbortController();
                    const signal = controllers[`${currentId}`].signal;
                    const safeQuery = query.replace(/["\\]/g, '\\$&')
                    const suggestUrl = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=query&resources[limit]=6`
                    const queryString = `{
                        search(query:"${safeQuery}", prefix:LAST, types:[PRODUCT], first:6) {
                            edges {
                                node {
                                    ... on Product {
                                        title
                                        vendor
                                        handle
                                        featuredImage {
                                            url
                                            altText
                                        }
                                        images(first:1) {
                                            edges {
                                                node {
                                                    url
                                                    altText
                                                }
                                            }
                                        }
                                        priceRange {
                                            minVariantPrice {
                                                amount
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }`
                    const options = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                        },
                        body: JSON.stringify({ query: queryString }),
                        signal
                    }

                    try {
                        const [response, suggestResponse] = await Promise.all([
                            fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, options),
                            fetch(suggestUrl)
                        ])
                        if (!response.ok) {
                            searchResults.value.content = true;
                            unsearched.value = false;
                            return;
                        }
                        const data = await response.json()
                        if (currentId !== requestId) return
                        const edges = data?.data?.search?.edges || []
                        const items = edges.map((edge) => {
                            const node = edge.node || {}
                            const featured = node?.featuredImage || {}
                            const imageNode = node?.images?.edges?.[0]?.node || {}
                            return {
                                title: node.title || '',
                                vendor: node.vendor || '',
                                handle: node.handle || '',
                                image: featured.url || imageNode.url || '',
                                alt: featured.altText || imageNode.altText || '',
                                price: promo.priceFormat(node?.priceRange?.minVariantPrice?.amount) || ''
                            }
                        })
                        searchResults.value.products = items;

                        let suggestions = []
                        if (suggestResponse.ok) {
                            const suggestData = await suggestResponse.json()
                            suggestions = suggestData?.resources?.results?.queries?.map((entry) => searchStore.inputTest(entry.text)[0]) || []
                        }
                        searchResults.value.suggestions = suggestions;
                        searchResults.value.content = true;
                        unsearched.value = false;
                        return;
                    } catch (error) {
                        if (error.name !== 'AbortError') {
                            console.error(error);
                        }
                        searchResults.value.content = true;
                        unsearched.value = false;
                        return;
                    }
                }, 250)
            }


            Vue.watch(searchTerm, (newInput) => {
                if(newInput.length > 2) {
                    predSearch(newInput);
                }
            })

            return {
                showSearchBox,
                showSearch,
                searchTerm,
                searchResults,
                unsearched,
                searchStore,
                keyPress
            };
        }
    })
    headerSearch.use(window.VueAppGlobals.pinia);
    headerSearch.mount('#headerSearchDropdown');
}

if (window.Vue && window.Pinia) {
    vueSearch();
} else {
    window.addEventListener('vue-ready', function () {
        vueSearch();
    });
}